import React from 'react';
import { setWaitlistOptedInCookie, setWaitlistSeenCookie } from '../utils/cookieManager';

interface WaitlistLandingProps {
  onOptinComplete: () => void;
  onSkipToTool: () => void;
}

const WAITLIST_LEARN_MORE_URL = 'https://closeiq.sellersynapse.com/';

const WaitlistLanding: React.FC<WaitlistLandingProps> = ({ onOptinComplete, onSkipToTool }) => {
  const handleLearnMore = () => {
    setWaitlistOptedInCookie();
    setWaitlistSeenCookie();
    onOptinComplete();
  };

  const handleSkipToTool = () => {
    setWaitlistSeenCookie();
    onSkipToTool();
  };

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center p-4 z-50 overflow-y-auto">
      <div className="max-w-6xl w-full">
        <div className="text-center mb-8">
          <img
            src="/PPC-analyzer-logo-transparent.png"
            alt="PPC Analyzer"
            className="h-16 w-auto mx-auto mb-4 drop-shadow-lg"
          />
        </div>

        <div className="bg-white rounded-3xl shadow-2xl border border-gray-200 overflow-hidden">
          <div className="flex flex-col min-h-[520px]">
            <div className="w-full p-8 lg:p-12 flex flex-col justify-center">
              <h1 className="text-4xl lg:text-6xl font-extrabold bg-gradient-to-r from-gray-900 to-blue-600 bg-clip-text text-transparent mb-6 leading-tight">
                What If You Could Turn PPC Audits Into a Lead Generation Machine?
              </h1>

              <div className="text-lg lg:text-xl text-gray-600 space-y-4">
                <p>
                  <span className="font-semibold text-gray-900">CloseIQ</span> lets Amazon agencies generate white-labeled PPC audits in 4 seconds—not 4 hours. Prospects upload their search term report, get instant results, and book calls. Your brand, your leads.
                </p>
                <p>Live now. Agencies are already using it to stand out and close faster.</p>
                <p className="font-semibold text-gray-700">
                  Early adopter pricing: $97/month (locks in forever). 7-day free trial.
                </p>
              </div>

              <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
                <a
                  href={WAITLIST_LEARN_MORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLearnMore}
                  className="inline-flex items-center justify-center px-6 py-4 text-lg font-semibold text-white bg-gradient-to-r from-[#c501ee] via-[#6b57ff] to-[#1e9ef8] rounded-xl shadow-lg hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-[#6b57ff40] transition-all"
                >
                  Learn More →
                </a>
                <button
                  type="button"
                  onClick={handleSkipToTool}
                  className="inline-flex items-center justify-center px-6 py-4 text-lg font-semibold text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
                >
                  Skip to free tool →
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-6 text-sm text-gray-500">
          <p>Secure • Private • No Spam</p>
        </div>
      </div>
    </div>
  );
};

export default WaitlistLanding;
